import React from 'react'
function Banner() {
  return (
    <>
      <section className='banner-section'>
        <div className="container">
          <div className="banner-content">
            <div className="banner-content__text">
              <h2>Save big with our cheap Superbike Rentals!</h2>
              <p>
                Top Airports. Local Suppliers, <span>24/7</span> Support.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Banner